export enum BucketPosition {
  TL = 0,
  TR = 1,
  BR = 2,
  BL = 3,
}
